import { Map, fromJS } from 'immutable';

export function request(state) {
    return state.set(
        'create',
        (state.get('create') || Map())
            .set('state', 'IN_PROGRESS')
            .set('errors', void 0)
            .set('debug', void 0)
    );
}

export function error(state, { errors, debug }) {
    return state.set(
        'create',
        (state.get('create') || Map())
            .set('state', 'ERROR')
            .set('errors', fromJS(errors))
            .set('debug', fromJS(debug))
    );
}

export function finish(state, { customer }) {
    return state
        .set(
            'create',
            (state.get('create') || Map())
                .set('customer', fromJS(customer))
                .set('state', 'FINISHED')
                .set('errors', void 0)
                .set('debug', void 0)
        );
}

export function clear(state) {
    return state.set('create', Map());
}
